import L from 'leaflet'
import type { Sample } from '../Model/index.js'

export function getMapCenterFromSamples(samples: Sample[], fallback: [number, number]): L.LatLngExpression {
  const coords = samples.map((s) => s.sampleMetadata?.sampleCoordinates?.coordinates).filter((c) => !!c)

  return getMapCenterFromCoordinates(coords, fallback)
}

export function getMapCenterFromCoordinates(coords: [number, number][], fallback: [number, number]): L.LatLngExpression {
  if (coords.length === 0) return fallback

  const [sumLat, sumLng] = coords.reduce(([latAcc, lngAcc], [lng, lat]) => [latAcc + lat, lngAcc + lng], [0, 0])

  return L.latLng(sumLat / coords.length, sumLng / coords.length)
}

export function getBoundsFromSamples(samples: Sample[]): L.LatLngBounds | null {
  const coords = samples
    .map((s) => s.sampleMetadata?.sampleCoordinates)
    .filter((c) => !!c)
    .map((c) => c.coordinates)

  return getBoundsFromCoordinates(coords)
}

export function getBoundsFromCoordinates(coords: [number, number][]): L.LatLngBounds | null {
  if (coords.length === 0) return null

  return L.latLngBounds(coords.map(([lng, lat]) => L.latLng(lat, lng)))
}
